module.exports = __webpack_public_path__ + "assets/img/SearchBAIOS.125abbd3.png";